<div class="is-flex form-group" [formGroup]="parentFormGroup">
  <div class="is-flex flex-one has-flex-align-center" *ngFor="let value of values; trackBy: trackBy" (click)="model = value.value">
    <div [class.selected]="value.value === model">
        <ng-container *ngIf="value.value === model">
            <svg ngNonBindable width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <rect id="path-1" x="0" y="0" width="22" height="22" rx="11"></rect>
                    <filter x="-4.5%" y="-4.5%" width="109.1%" height="109.1%" filterUnits="objectBoundingBox" id="filter-2">
                        <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
                        <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
                        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                        <feColorMatrix values="0 0 0 0 0.768627451   0 0 0 0 0.776470588   0 0 0 0 0.784313725  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
                    </filter>
                </defs>
                <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-170.000000, -516.000000)">
                    <g  transform="translate(10.000000, 48.000000)">
                        <g id="Radio_Button_Selected" transform="translate(161.000000, 469.000000)">
                            <rect stroke="#007DC3" stroke-width="1" fill="#FFFFFF" x="0" y="0" width="22" height="22" rx="11"></rect>
                            <circle id="Oval" fill="#007DC3" cx="11" cy="11" r="3.5"></circle>
                        </g>
                    </g>
                </g>
            </svg>
        </ng-container>
        <ng-container *ngIf="value.value !== model">
            <svg ngNonBindable width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <rect id="path-1" x="0" y="0" width="22" height="22" rx="11"></rect>
                    <filter x="-4.5%" y="-4.5%" width="109.1%" height="109.1%" filterUnits="objectBoundingBox" id="filter-2">
                        <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
                        <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
                        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                        <feColorMatrix values="0 0 0 0 0.768627451   0 0 0 0 0.776470588   0 0 0 0 0.784313725  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
                    </filter>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-11.000000, -516.000000)">
                    <g transform="translate(10.000000, 48.000000)">
                        <g transform="translate(2.000000, 469.000000)">
                            <g>
                                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use>
                                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                                <use stroke="#007DC3" stroke-width="1" xlink:href="#path-1"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </ng-container>
    </div>
    <label *ngIf="value.labelKey">{{value.labelKey | translate}}</label>
    <!-- <div class="text" [class.selected]="value.value === model">{{ value.labelKey | translate }}</div> -->
    <input type="radio" class="hidden" [formControl]="formControl" [value]="value.value" />
  </div>
</div>
